import {
  HOTEL_GROUP_USERS_REQUEST,
  HOTEL_GROUP_USERS_REQUEST_ERROR,
  HOTEL_GROUP_USERS_REQUEST_RECEIVED,
  HOTEL_GROUP_USERS_UNLOAD,
} from "./types";

export const hotelGroupUsers = (
  state = {
    hotelGroupUsers: {},
    isFetchingHotelGroupUsers: false,
    hotelGroupUsersError: false,
  }, action) => {
  switch (action.type) {
    case HOTEL_GROUP_USERS_REQUEST:
      return {
        ...state,
        isFetchingHotelGroupUsers: true,
      };
    case HOTEL_GROUP_USERS_REQUEST_RECEIVED:
      return {
        ...state,
        hotelGroupUsers: action.data?.data || [],
        hotelGroupUsersError: false,
        isFetchingHotelGroupUsers: false,
      };
    case HOTEL_GROUP_USERS_REQUEST_ERROR:
      return {
        ...state,
        hotelGroupUsers: [],
        isFetchingHotelGroupUsers: false,
        hotelGroupUsersError: true,
      };
    case HOTEL_GROUP_USERS_UNLOAD:
      return {
        ...state,
        hotelGroupUsers: [],
        isFetchingHotelGroupUsers: false,
        hotelGroupUsersError: false,
      };
    default:
      return state;
  }
};